







import { defineComponent } from '@vue/composition-api'
import type { PropType } from '@vue/composition-api'
import type { TranslateResult } from 'vue-i18n'

export default defineComponent({
  name: 'ExternalLink',

  props: {
    label: {
      type: [] as PropType<string | TranslateResult>,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  }
})
